
import React, { ChangeEvent, Component } from 'react';
import { find, sortBy } from 'lodash';
import { getMomentTZDateTime } from 'ts-util';
import tsRest from 'ts-rest-client';

import { EventDateDisplayMode, EventDateInfo, PromoInfoShort } from '../../../mvcapi/models/common';


import { Combo } from '../../atoms';
import { PromoProposalControl } from '../promotions/promo-proposal-control';
import { PromoSelectorButtons } from '../promotions';

import { SaleMessagesInfo } from './salemessagesinfo';

import { PleaseWaitSpinner } from '../../../../jsxctl/utilctl';

import TranslateManager from 'ts-translate-js';
import { ButtonsList } from '../../molecules';
import { checkHasSameVenueNames, getEventDateDisplayMode, getFilteredEventDateInfos } from '../../../logic/sales-util';
import { EMPTY_UUID } from '../../../logic';

const tr = TranslateManager.boundTR;

interface EventDateSelectionProps {
    eventDateInfos: EventDateInfo[];
    selectedEventDate?: EventDateInfo;
    onChangeEventDate?: (eventDateInfo: EventDateInfo, triggerBuy?: boolean) => void;
    onBuyClick?: () => void;
    // onModifyThisStep?: () => void;
    returnToPackageUrl?: string;
    loadingProductInfo?: boolean;
    onPromoUpdated?: () => void;
    onContentChange?: () => void;
    onMembershipPresaleClick?: (membershipTypeID: number, isInMembershipCardPreSaleAndHaveValidCard: boolean) => void;
    hiddenPromo?: boolean;
    integ?: string;
    isProgram: boolean;
}

interface EventDateSelectionState {
    showMembercardPopup: boolean;
    //membershipTypeInfos: MembershipTypeSaleInfo[];
    showPromoSelector?: boolean;
    showInternetNameInCombo?: boolean;
}

interface EventDateItem {
    ID: number;
    LongName: string;
    Date: Date;
    VenueName?: string;
    ShortName?: string;
    Status?: string;
    DateToDisplay?: string;
    IsSoldOut: boolean;
    IsInSale: boolean;
}

export class EventDateSelection extends Component<EventDateSelectionProps, EventDateSelectionState> {
    // defaultProps
    static readonly defaultProps: Partial<EventDateSelectionProps> = {
        loadingProductInfo: false,
        isProgram: false,
        returnToPackageUrl: ""
    };

    modalContainerRef: React.RefObject<HTMLDivElement>;

    constructor(props: EventDateSelectionProps) {
        super(props);
        
        this.state = {
            showMembercardPopup: false,
            //membershipTypeInfos: []
        };

        this.modalContainerRef = React.createRef();

        this.handleSeeOurPromoOnClick = this.handleSeeOurPromoOnClick.bind(this);
        this.getDateItem = this.getDateItem.bind(this);
        this.handleChangeEvent = this.handleChangeEvent.bind(this);
        this.handleClickEvent = this.handleClickEvent.bind(this);
        this.handleBuyOnClick = this.handleBuyOnClick.bind(this);
        this.handlePromoSelectorOnClose = this.handlePromoSelectorOnClose.bind(this);
    }

    componentDidMount() { 
        this.loadDisplayInfo(); 
    }

    handleBuyOnClick() {
        if(this.props.onBuyClick !== undefined) this.props.onBuyClick();
    }


    handleChangeEvent(e: ChangeEvent<HTMLSelectElement>) {
        const itemSelected = find(this.props.eventDateInfos, ['EventDateID', parseInt(e.target.value)]);
        this.props.onChangeEventDate(itemSelected);
    }

    handleClickEvent(eventDateID: number) {
        const itemSelected = find(this.props.eventDateInfos, { EventDateID: eventDateID });

        this.props.onChangeEventDate(itemSelected, true);
    }

    handleSeeOurPromoOnClick() {
        if (this.props.selectedEventDate.Packages.length > 1)
            this.setState({ showPromoSelector: true });
        else
            parent.location.href = this.props.selectedEventDate.SeePromoLink;
    }

    handlePromoSelectorOnClose() {
        this.setState({showPromoSelector : false});
    }

    /*
        handleOnModifyClick() {
        this.props.onModifyThisStep();
        },
        */

    loadDisplayInfo(){
        // Load the combo date display
        tsRest.get("/integration/" + this.props.integ + "/showinternetnameincombo")
                .done((info) => {
                    this.setState({ showInternetNameInCombo: info });
                });
    }

    getDateItem(eventDateInfo: EventDateInfo) {
        let item: EventDateItem = {
            ID: 0,
            LongName: '',
            Date: undefined,
            VenueName: eventDateInfo.VenueName,
            ShortName: '',
            DateToDisplay: '',
            IsSoldOut: eventDateInfo.IsSoldOut,
            IsInSale: eventDateInfo.IsInSale
        };

        let newdate = "";
        let status = "";
        let internetName = "";
        
        if (this.state.showInternetNameInCombo && !eventDateInfo.HasSameNames)
            internetName = eventDateInfo.ProductName;

        if(eventDateInfo.IsNewDate)
            newdate = " (" + tsapp.tr("program.eventdateinfo.newdate") + ") ";
        if(eventDateInfo.SeatsAvailability == "SEATS_AVAILABILITY_SOLDOUT")
            status = " (" + tsapp.tr("program.eventdateinfo.soldout") + ") ";
        else if(eventDateInfo.SeatsAvailability == "SEATS_AVAILABILITY_FEW_SEATS")
            status = " (" + tsapp.tr("program.eventdateinfo.fewseats") + ") ";
        // else if(eventDateInfo.InSaleStatus === InSaleStatus.SALENOTEND)
        //     status = " (" + tsapp.tr("program.eventdateinfo.offline")+ ") ";

        item.ID = eventDateInfo.EventDateID;

        if(eventDateInfo.DateToBeDeterminated)
            item.DateToDisplay = tsapp.tr("Date à déterminer");
        else
            item.DateToDisplay = getMomentTZDateTime(eventDateInfo.Date, eventDateInfo.TimeZone.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"));


        item.ShortName = internetName;
        item.Status = newdate + status;
        item.LongName = [item.DateToDisplay, item.ShortName].filter(Boolean).join(" - ") + item.Status;
        item.Date = eventDateInfo.Date;

        return item;
    }

    // getPromoBtnUrl() {
    //     var retUrl = "";
    //     if(this.props.selectedEventDate.Packages.length == 1)
    //         retUrl = this.props.selectedEventDate.Packages[0].ProductInfoURL;

    //     return retUrl != undefined && retUrl != "" ? retUrl : this.props.returnToPackageUrl;
    // }

    render() {
        //var processing = false; // PAS UTILISÉ?!?!?
        let eventDateInfoDisplay = null;
        let saleMessageInfo = null;
        let btnPackage = null;
        let promoSelector = null;

        let filteredEventDateInfos = getFilteredEventDateInfos(this.props.eventDateInfos);

        let displayVenueName = !checkHasSameVenueNames(filteredEventDateInfos);

        const displayMode: EventDateDisplayMode = getEventDateDisplayMode(filteredEventDateInfos);

        // Affichage du bouton d'achat
        let btnBuy = null;
        if(this.props.selectedEventDate != null) {
            if(this.props.loadingProductInfo) {
                btnBuy = <div className="form-group"><PleaseWaitSpinner /></div>;
            }
            else
            {
                if(this.props.selectedEventDate.IsSoldOut)
                {
                    btnBuy = <button type="button" className="btn btn-primary disabled text-uppercase btn-xs-mobile">{tsapp.tr("program.eventdateinfo.soldout")}</button>;
                }
                else
                {
                    if(!this.props.selectedEventDate.IsInSale)
                        btnBuy = <button type="button" className="btn btn-primary disabled text-uppercase btn-xs-mobile">{tsapp.tr("program.eventdateinfo.buy")}</button>;
                    else
                        btnBuy = <button type="button" className="btn btn-primary text-uppercase btn-xs-mobile" onClick={this.handleBuyOnClick}>{tsapp.tr("program.eventdateinfo.buy")}</button>;
                }
            }

            const hasPackages = ((this.props.selectedEventDate.SeePromoLink && this.props.selectedEventDate.SeePromoLink != "")
            || (this.props.selectedEventDate.Packages && this.props.selectedEventDate.Packages.length > 0));


            promoSelector = <PromoSelectorButtons 
                container={this.modalContainerRef.current}
                packages={this.props.selectedEventDate.Packages} 
                onClose={this.handlePromoSelectorOnClose} 
            />;

            if (hasPackages) {
                // pas de bouton promo si le lien url et pas de packages est inexistant
                btnPackage = (
                    <button 
                        type="button" 
                        className="btn btn-default text-uppercase btn-xs-mobile" 
                        onClick={this.handleSeeOurPromoOnClick}
                    >
                        <span className="fa fa-tag" aria-hidden="true"/>
                        <span> {tsapp.trN("Voir notre promotion","Voir nos promotions",  {n: (this.props.selectedEventDate.Packages ? this.props.selectedEventDate.Packages.length: 1)})}</span>
                    </button>
                );
            }
        }

        let iteminfos = filteredEventDateInfos.map((eventDateInfo) => {
            return this.getDateItem(eventDateInfo);
        });

        iteminfos = sortBy(iteminfos, 'Date');

        const buttonInfos = iteminfos.map((item) => {
            let venueName = displayVenueName && item.VenueName;
            let infoSupp = [item.ShortName, venueName].filter(Boolean).join(", ");

            return { 
                class: "active btn-primary", 
                children: <>
                    <div>{item.DateToDisplay + item.Status}</div>
                    {infoSupp && <div className="info-supp">{infoSupp}</div>}
                </>, 
                onClick: () => this.handleClickEvent(item.ID), 
                disabled: item.IsSoldOut
            };
        });

        const selectedEventDateID = this.props.selectedEventDate != null ? this.props.selectedEventDate.EventDateID : null;
        eventDateInfoDisplay = (displayMode == "button"
            ? <div className="button-list">
                    <h3>{tsapp.tr("program.eventdateinfo.selectadate")}</h3>
                    <ButtonsList buttonInfos={buttonInfos} />
                </div>
            : <div className="row">
                <div className="text-center">
                    <h3>{tsapp.tr("program.eventdateinfo.selectadate")}</h3>
                </div>
                <div className="text-center">
                    <form className="form-inline">
                        <div className="form-group cmbDateSelection">
                            <Combo className="form-control" valueField="ID" textField="LongName" selectedValue={selectedEventDateID} onChange={this.handleChangeEvent} items={iteminfos} emptyComboMessage={tr("program.eventdateinfo.nodateavailable")}/>
                        </div>
                        <div className="form-group">
                            {btnBuy}{btnPackage}
                        </div>
                    </form>
                </div>
            </div>
        );

        /*if overview
            eventDateInfoDisplay = <ProductOverview
            name={this.getDateComboItem(this.state.eventDateInfoSelected).Name}
            onModifyThisStep={this.props.isProgram ? this.handleOnModifyClick : null}
            onContentChange={this.props.onContentChange} />;

            }*/

        let promoInfo: PromoInfoShort;
        if(displayMode == "combo") // Prendre le promoInfo de la date sélectionnée comme avant
            promoInfo = this.props.selectedEventDate != null ? this.props.selectedEventDate.PromoInfo : undefined;
        else // Prendre le premier promoInfo trouvé car ils seront tous les mêmes
            promoInfo = filteredEventDateInfos.map(eventDateInfo => eventDateInfo.PromoInfo).find(promoInfo => promoInfo != null && promoInfo.PromoID != EMPTY_UUID);

        if(this.props.selectedEventDate != null && !this.props.selectedEventDate.IsInSale) 
            saleMessageInfo = <SaleMessagesInfo eventDateInfo={this.props.selectedEventDate} onMembershipPresaleClick={this.props.onMembershipPresaleClick} onContentChange={this.props.onContentChange}></SaleMessagesInfo>;

        return (
            <div className="eventdateinfo row">
                <div className="col-xs-12 col-sm-offset-1 col-sm-10 text-center">
                    {eventDateInfoDisplay}
                    {
                        promoInfo && <PromoProposalControl 
                            promoInfo={promoInfo}
                            hiddenPromo={this.props.hiddenPromo}
                            showProposalMessage={true}
                            onPromoUpdated={this.props.onPromoUpdated}
                            onContentChange={this.props.onContentChange}   
                            isAPackageSale={false}
                        />
                    }
                </div>
                <div className="col-xs-12 col-sm-offset-2 col-sm-8">
                    {saleMessageInfo}
                </div>
                <div ref={this.modalContainerRef}></div>
                {displayMode == "combo" && this.state.showPromoSelector && promoSelector}
            </div>);
    }

}